import { render } from "./linkButton.vue?vue&type=template&id=3d47ad52&scoped=true"
import script from "./linkButton.vue?vue&type=script&lang=js"
export * from "./linkButton.vue?vue&type=script&lang=js"

import "./linkButton.vue?vue&type=style&index=0&id=3d47ad52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d47ad52"]])

export default __exports__